angular.module('env.data.services.permissions', [])

    .service('permissions', function permissions($q, $log, usersRepository) {

            /**
             * Promise.
             * Checks if it is allowed or not for a user to 'see/move items to' particular Order step (state).
             * @param stepId - ID of the step (state) to test for
             */
            this.isStepTransitionAllowed = function (stepId) {
                return usersRepository.getCurrentUser().then(
                    function (restUser) {
                        return _.any(restUser.$model.permissions, function (p) {
                            return p.operation == '/Workflow' ||
                                p.operation == _.str.sprintf('/Workflow/Step:%s', stepId) ||
                                _.str.startsWith(p.operation, _.str.sprintf('/Workflow/Step:%s/Action', stepId));
                        });
                    },
                    function (error) {
                        $log.warn(_.string.sprintf("Exception during checking if user allowed to 'see/move order to' step. Error: %s", error));
                        return $q.reject(error);
                    });
            };

            this.isActionAllowed = function (stepId, actionId) {
                return usersRepository.getCurrentUser().then(
                    function (restUser) {
                        return _.any(restUser.$model.permissions, function (p) {
                            return p.operation == '/Workflow' ||
                                p.operation == _.str.sprintf('/Workflow/Step:%s', stepId) ||
                                p.operation == _.str.sprintf('/Workflow/Step:%s/Action:%s', stepId, actionId);
                        });
                    },
                    function (error) {
                        $log.warn(_.string.sprintf("Exception during checking if user allowed to 'see/move order to' step. Error: %s", error));
                        return false;
                    });
            };
            return this;
        }
    );